import { useEffect, useState } from 'react';
import { ACTIVITY_API_CALL_BOUNCE, BulkTicketActivities, fireDispatchTabTicketActivitiesEvent } from '..';
import { getBulkActivitiesForTickets } from '../../TicketActivityListener/ticketActivityHelper';

async function listenTicketActivities(ticketKeyListString: string, fireEvent = false) {
    try {
        const response = await getBulkActivitiesForTickets(ticketKeyListString);
        if (!fireEvent) return response.data;
        fireEvent && fireDispatchTabTicketActivitiesEvent(response.data);
    } catch (error) {
        console.error(`listenTicketActivities , error:`, error);
    }
}

export default function useBulkTicketActivities(ticketKeyList: string, fireEvent = false) {
    const [activities, setActivities] = useState<BulkTicketActivities>({});
    useEffect(() => {
        const bulkActivities =
            ticketKeyList &&
            setInterval(() => {
                listenTicketActivities(ticketKeyList, fireEvent).then((newActivities) => {
                    !fireEvent && newActivities && setActivities(newActivities);
                });
            }, ACTIVITY_API_CALL_BOUNCE);
        return () => {
            clearInterval(bulkActivities);
        };
    }, [ticketKeyList, fireEvent]);

    return activities;
}
